const parseInitials = (input: string): string => {
    const output = input
        ?.split(" ")
        .filter(word => !["&"].includes(word))
        .map(word => word.substring(0, 1))
        .join("")
        .slice(0, 2);
    return output;
};
export { parseInitials };
